<template>
  <v-dialog persistent v-model="isShowModal" max-width="1100px">
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <h3 class="text-xs-center py-2 my-2">
                Predefined PDF
              </h3>
            </v-flex>
            <v-flex xs12>
              <div class="imageSize">
                <img :src="imgSrc" alt="">
              </div>
            </v-flex>
            <v-flex xs12 class="text-xs-center py-2">
              <v-btn
                color="blue darken-1"
                flat="flat"
                @click="closeModal"
              >
                close
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'predefinedImageModel',
    props: {
      isShow: {
        default: false,
        required: true,
        type: Boolean
      },
      imgSrc: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        isShowModal: false
      }
    },
    // it was solution if back gives .jpeg format
    // computed: {
    //   predefinedImage () {
    //     const img = new Image()
    //     let blob = new Blob([ img ], { type: 'data:image/jpeg;base64' })
    //     img.src = window.URL.createObjectURL(blob)
    //     return img.src
    //   }
    // },
    watch: {
      isShow: {
        handler () {
          this.isShowModal = this.isShow
        },
        immediate: true,
      },
      isShowModal (val) {
        if (!val) this.closeModal()
      }
    },
    methods: {
      closeModal () {
        this.$emit('close')
      }
    }
  }
</script>

<style>
  .imageSize {
    display: block;
    border: 2px solid #00edbf;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Listing/ListingList/predefinedImageModel.vue